import { render } from "./Clicks.vue?vue&type=template&id=522322e8"
import script from "./Clicks.vue?vue&type=script&lang=js"
export * from "./Clicks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__